import { BrowserRouter, Switch, Route, BrowserRouter as Router } from 'react-router-dom';

import React, { useState } from 'react';
import Header from './components/Elements/header/header';
import ConvertNumber from './components/ConvertNumber';
import './assets/scss/main.scss';

import Loader from './components/Loader';
import Error_blendy_zakladania_umowy from './pages/erroe-blendy-zakladania-umowy';
import Error_nie_znaleziono_uzytkownika from './pages/error-nie-znaleziono-uzytkownika';
import Error_ogolny from './pages/error-ogolny';
import Error_przypominanie_hasla from './pages/error-przypominanie-hasla';
import Error_sesja_wygasla from './pages/error-sesja-wygasla';
import Error_token_wygasl from './pages/error-token-wygasl';
import Error_zajety_login from './pages/error-zajety-login';
import Karta_platnicza_dodano from './pages/karta-platnicza-dodano';
import KartaPlatniczaError from './pages/karta-platnicza-error';
import Login from './pages/login';
import Login_error from './pages/login-error';
import Login_error_key from './pages/login-error-key';
import Login_haslo_zmienione from './pages/login-haslo-zmienione';
import Login_zmien_haslo from './pages/login-zmien-haslo';
import Odzyskaj_haslo from './pages/odzyskaj-haslo';
import Odzyskaj_konto from './pages/odzyskaj-konto';
import Odzyskaj_konto_wyslane from './pages/odzyskaj-konto-wyslane';
import Operacja_w_toku from './pages/operacja-w-toku';
import Osoba_powiazana_dodaj from './pages/osoba-powiazana-dodaj';
import Osoba_powiazana_dodano from './pages/osoba-powiazana-dodano';
import Osoba_powiazana_edytuj from './pages/osoba-powiazana-edytuj';
import Osoba_powiazana_error from './pages/osoba-powiazana-error';
import Osoba_powiazana_potwierdz from './pages/osoba-powiazana-potwierdz';
import OsobaPowiazanaPotwierdzenie from './pages/osoba-powiazana-potwierdzenie';
import Platnosc from './pages/platnosc';
import Platnosc_nieudana from './pages/platnosc-nieudana';
import Potwierdzenie_zakupu from './pages/potwierdzenie-zakupu';
import Potwierdzenie_zakupu_powturne from './pages/potwierdzenie-zakupu-powturne';
import Potwierdz_konto from './pages/potwierdz-konto';
import Potwierdz_rejestracje_konta from './pages/potwierdz-rejestracje-konta';
import Profil_harmonogram from './pages/profil-harmonogram';
import Profil_ja from './pages/profil-ja';
// import profil_ja_edycja from './pages/profil-ja-edycja';
import Profil_karty_platnicze from './pages/profil-karty-platnicze';
import Profil_osoba_powiazana_dodaj from './pages/profil-osoba-powiazana-dodaj';
import Profil_osoba_powiazana_potwierdz from './pages/profil-osoba-powiazana-potwierdz';
import Profil_osoba_powiazana_dodano from './pages/profil-osoba-powiazana-dodano';
import Profil_osoba_powiazana_edytuj from './pages/profil-osoba-powiazana-edytuj';
import Profil_powiazane from './pages/profil-powiazane';
import Profil_umowy_aktywne from './pages/profil-umowy-aktywne';
import Profil_umowy_archiwalne from './pages/profil-umowy-archiwalne';
import Rejestracja_dane from './pages/rejestracja-dane';
import Rejestracja_error from './pages/rejestracja-error';
import Rejestracja_haslo from './pages/rejestracja-haslo';
import Rejestracja_potwierdzenie from './pages/rejestracja-potwierdzenie';
import Umowa from './pages/umowa';
import Wybor_opcji_1_uczestnik from './pages/wybor-opcji-1-uczestnik';
import Wybor_opcji_2_data from './pages/wybor-opcji-2-data';
import Wybor_opcji_3_wariant from './pages/wybor-opcji-3-wariant';
import Wybor_opcji_4_forma_platnosci from './pages/wybor-opcji-4-forma-platnosci';
import Wybor_opcji_5_raty from './pages/wybor-opcji-5-raty';
import LoginBychname from './pages/login-bychname';
import ContentWrapper from './components/content-wrapper';
import StudentCard from './components/studentCard/studentCard';
import Menu from './components/menu/menu';
import LoginBuy from './pages/buy/login/loginBuy';
import LoginBuyToConfirm from './pages/buy/login/loginBuyToConfirm'
import ChooseUserBuy from './pages/chooseUserBuy/chooseUserBuy';
import Summary from './pages/summary/summary';
import PaymentChoose from './pages/summary/Payment/paymentChoose';
import InProgress from './pages/InProgress/InProgress';
import WelcomePage from './pages/buy/login/welcomePage/welcomePage';
import Register from './pages/buy/login/register/register';
import Maps from './pages/maps/maps';
import EDSFooter from './components/EDSFooter';
import App_contract from './components/app-contract';
import ThankYou from './pages/summary/thankYou/thankYou';
import CampWrapper from './pages/camp/campSummary';
import ConfirmBuy from './pages/confirmBuy/confirmBuy';
import { Provider } from 'react-redux';
import { store } from './reducers';
import { useRef } from 'react';
import ContractDownload from "./components/pulpit/getContract"
import { GoogleOAuthProvider} from '@react-oauth/google';
require('helvatica-neue-lt/index.css');

const App = () => {
    const loaderComponent = useRef();
    const loader = {
        startTask: (taskConfig = null) => {
            if (
                typeof loaderComponent === 'object' &&
                loaderComponent !== null &&
                typeof loaderComponent.current === 'object' &&
                loaderComponent.current !== null &&
                typeof loaderComponent.current.startTask === 'function'
            ) {
                return loaderComponent.current.startTask(taskConfig);
            } else {
                return false;
            }
        },
        endTask: (taskUUID) => {
            if (
                typeof loaderComponent === 'object' &&
                loaderComponent !== null &&
                typeof loaderComponent.current === 'object' &&
                loaderComponent.current !== null &&
                typeof loaderComponent.current.endTask === 'function'
            ) {
                return loaderComponent.current.endTask(taskUUID);
            } else {
                return false;
            }
        },
    };
    window.edsLoader = loader;

    return (
        <>
            <Loader ref={loaderComponent}></Loader>
            
                <Provider store={store}>
                <GoogleOAuthProvider clientId="521507719932-racjj88bkdap9m51g3tb8k8860cbpot2.apps.googleusercontent.com">
                    <BrowserRouter>
                        <Switch>
                       
                                <Route path="/Student_card" component={ContentWrapper} />
                                <Route path="/Pulpit" component={ContentWrapper} />
                                <Route path="/Courses" component={ContentWrapper} />
                                <Route path="/Events" component={ContentWrapper} />
                                <Route path="/Workshops" component={ContentWrapper} />
                                <Route path="/Departures" component={ContentWrapper} />
                                <Route path="/To_pay/:courseHeadingId?" component={ContentWrapper} />
                                <Route path="/Payment_history" component={ContentWrapper} />
                                <Route path="/Current_classes" component={ContentWrapper} />
                                <Route path="/Todo_classes" component={ContentWrapper} />
                                <Route path="/Customer_service" component={ContentWrapper} />
                                <Route path="/Maps" component={ContentWrapper} />
                                <Route path="/FAQ" component={ContentWrapper} />
                                <Route path="/ThankYou" component={ThankYou} />
                                <Route path="/CampThankYou" component={ThankYou} />
                                {/* <Route path="/Setting" component={ContentWrapper} /> */}
                                <Route exact path="/Setting/:order?" component={ContentWrapper} />
                                <Route path="/Next_invoice" component={ContentWrapper} />
                                <Route path="/Register" component={Register} />
                                <Route
                                    path="/Welcome/key/:courseHeadingId?"
                                    component={WelcomePage}
                                />
                                <Route
                                    path="/Welcome"
                                    component={WelcomePage}
                                />
                                <Route path="/Contract" component={ContractDownload} />
                                <Route path="/RODO" component={Register} />
                                <Route path="/inProgress" component={InProgress} />
                                <Route path="/Summary" component={Summary} />
                                <Route path="/Confirm" component={ConfirmBuy} />
                                <Route path="/Camp" component={CampWrapper} />
                                <Route path="/Statue" component={Register} />
                                <Route
                                    path="/error_nie_znaleziono_uzytkownika"
                                    component={Error_nie_znaleziono_uzytkownika}
                                />
                                <Route path="/error_ogolny" component={Error_ogolny} />
                                <Route
                                    path="/error_przypominanie_hasla"
                                    component={Error_przypominanie_hasla}
                                />
                                <Route
                                    path="/error_blendy_zakladania_umowy"
                                    component={Error_blendy_zakladania_umowy}
                                />
                                <Route
                                    path="/error_sesja_wygasla"
                                    component={Error_sesja_wygasla}
                                />
                                <Route path="/error_token_wygasl" component={Error_token_wygasl} />
                                <Route path="/error_zajety_login" component={Error_zajety_login} />
                                <Route
                                    path="/karta_platnicza_dodano/:sessionId?"
                                    component={Karta_platnicza_dodano}
                                />
                                <Route
                                    path="/karta_platnicza_error"
                                    component={KartaPlatniczaError}
                                />
                                <Route path="/login_error" component={Login_error} />
                                <Route path="/login_error_key" component={Login_error_key} />
                                <Route
                                    path="/login_haslo_zmienione/:courseHeadingId?"
                                    component={Login_haslo_zmienione}
                                />
                                <Route path="/login_zmien_haslo" component={Login_zmien_haslo} />
                                <Route path="/odzyskaj_haslo" component={Odzyskaj_haslo} />
                                <Route path="/odzyskaj_konto" component={Odzyskaj_konto} />
                                <Route
                                    path="/odzyskaj_konto_wyslane"
                                    component={Odzyskaj_konto_wyslane}
                                />
                                <Route path="/operacja_w_toku" component={Operacja_w_toku} />
                                <Route
                                    path="/osoba_powiazana_dodaj"
                                    component={Osoba_powiazana_dodaj}
                                />
                                <Route
                                    path="/osoba_powiazana_edytuj"
                                    component={Osoba_powiazana_edytuj}
                                />
                                <Route
                                    path="/osoba_powiazana_error"
                                    component={Osoba_powiazana_error}
                                />
                                <Route
                                    path="/osoba_powiazana_potwierdz"
                                    component={Osoba_powiazana_potwierdz}
                                />
                                <Route
                                    path="/osoba_powiazana_dodano"
                                    component={Osoba_powiazana_dodano}
                                />
                                <Route
                                    path="/osoba_powiazana_potwierdzenie"
                                    component={OsobaPowiazanaPotwierdzenie}
                                />
                                <Route path="/platnosc" component={Platnosc} />
                                <Route path="/platnosc_nieudana" component={Platnosc_nieudana} />
                                <Route
                                    path="/potwierdzenie_zakupu/:session?"
                                    component={Potwierdzenie_zakupu}
                                />

                                <Route
                                    path="/potwierdzenie_zakupu_powturne"
                                    component={Potwierdzenie_zakupu_powturne}
                                />
                                <Route path="/potwierdz_konto" component={Potwierdz_konto} />
                                <Route
                                    path="/potwierdz_rejestracje_konta"
                                    component={Potwierdz_rejestracje_konta}
                                />
                                <Route path="/profil_harmonogram" component={Profil_harmonogram} />

                                {/* <Route path='/profil_ja_edycja' component={profil_ja_edycja} /> */}
                                <Route
                                    path="/profil_karty_platnicze"
                                    component={Profil_karty_platnicze}
                                />
                                <Route
                                    path="/profil_osoba_powiazana_dodaj"
                                    component={Profil_osoba_powiazana_dodaj}
                                />
                                <Route
                                    path="/profil_osoba_powiazana_potwierdz"
                                    component={Profil_osoba_powiazana_potwierdz}
                                />
                                <Route
                                    path="/profil_osoba_powiazana_dodano"
                                    component={Profil_osoba_powiazana_dodano}
                                />
                                <Route
                                    path="/profil_osoba_powiazana_edytuj"
                                    component={Profil_osoba_powiazana_edytuj}
                                />
                                <Route path="/profil_powiazane" component={Profil_powiazane} />
                                <Route
                                    path="/profil_umowy_aktywne"
                                    component={Profil_umowy_aktywne}
                                />
                                <Route
                                    path="/profil_umowy_archiwalne"
                                    component={Profil_umowy_archiwalne}
                                />
                                <Route path="/rejestracja_dane" component={Rejestracja_dane} />
                                <Route path="/rejestracja_error" component={Rejestracja_error} />
                                <Route path="/rejestracja_haslo" component={Rejestracja_haslo} />
                                <Route
                                    path="/rejestracja_potwierdzenie"
                                    component={Rejestracja_potwierdzenie}
                                />
                                <Route path="/umowa" component={Umowa} />

                                <Route
                                    path="/LoginBuy/key/:courseHeadingId?"
                                    component={LoginBuy}
                                />
                                 <Route
                                    path="/LoginBuy"
                                    component={LoginBuy}
                                />
                                <Route
                                    path="/wybor_opcji_1_uczestnik"
                                    component={Wybor_opcji_1_uczestnik}
                                />
                                <Route path="/wybor_opcji_2_data" component={Wybor_opcji_2_data} />
                                <Route
                                    path="/wybor_opcji_3_wariant"
                                    component={Wybor_opcji_3_wariant}
                                />
                                <Route
                                    path="/wybor_opcji_4_forma_platnosci"
                                    component={Wybor_opcji_4_forma_platnosci}
                                />
                                <Route path="/wybor_opcji_5_raty" component={Wybor_opcji_5_raty} />
                                <Route path="/app_contract" component={App_contract} />
                                <Route
                                    path="/taniec"
                                    component={() => {
                                        window.location.href = 'https://taniec.com.pl';
                                        return null;
                                    }}
                                />
                                <Route
                                    path="/taniec_kurs"
                                    component={() => {
                                        window.location.href =
                                            'https://taniec.com.pl/ch/wybierz-kurs';
                                        return null;
                                    }}
                                />
                                <Route  path="/ConfirmLogin/:id" component={LoginBuyToConfirm} />
                                <Route  path="/key/:courseHeadingId" component={LoginBuy} />
                                <Route  path="/" component={Register} />
                            
                        </Switch>
                    </BrowserRouter>
                    </GoogleOAuthProvider>
                </Provider>
                {/* <div className="footerWrapper OO" style={{ marginTop: '50px' }}> */}
                <EDSFooter></EDSFooter>
            {/* </div> */}
        </>
    );
};
export default App
